module.exports = require('@nerdwallet/structured-content-core/migrations');
